import React from 'react';
import { Plus } from 'lucide-react';

import { Button } from '@epoch-ui/components/Button';
import SurveyTemplateIcon from 'components/common/icons/SurveyTemplateIcon';

interface EventEditorEmptyQuestionsProps {
  disabled?: boolean;
  onStartFromScratch: () => void;
  onUseTemplate: () => void;
}

export const EventEditorEmptyQuestions: React.FC<EventEditorEmptyQuestionsProps> = ({
  onStartFromScratch,
  onUseTemplate,
  disabled
}) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-dashed tw-border-border-grey tw-bg-background tw-py-8">
      <div className="tw-flex tw-gap-3">
        <Button
          variant="secondary"
          size="sm"
          className="tw-gap-1 tw-rounded-[8px] tw-leading-4"
          disabled={disabled}
          onClick={onStartFromScratch}
        >
          <Plus size={16} className="tw-text-dark-black" />
          Start from scratch
        </Button>
        <Button
          variant="secondary"
          size="sm"
          className="tw-rounded-[8px] [&>svg]:tw-mr-1 [&>svg]:tw-fill-dark-black"
          disabled={disabled}
          onClick={onUseTemplate}
        >
          <SurveyTemplateIcon />
          Use a template
        </Button>
      </div>
    </div>
  );
};
